import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

// export async function getTransaction() {
//     try {
//         const response = await serviceContext.get(ReportsURL + "transactions", null, options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

export async function postTransaction(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}transaction`, JSON.stringify(data), options); //+ "transactions", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postTransaction2(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}transaction2`, JSON.stringify(data), options); //+ "transactions", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postTransactionData(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}transaction/detail`, JSON.stringify(data), options); //+ "transactions/detail", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

// export async function postTransactionCsv(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "transactions/csv", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

// export async function postTransactionPdf(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "transactions/pdf", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

export async function postUserList(data) {

    try {
        const response = await serviceContext.post(ReportsURL + "userslist", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postSettlementReport(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}settlement`, JSON.stringify(data), options); //+ "settlements", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function depositeWithdrawTotal(data) {

    try {
        const response = await serviceContext.post(ReportsURL + "depowith/total", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function userCountTotal(data) {

    try {
        const response = await serviceContext.post(ReportsURL + "user/role/count", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function dashboardDepoWithDetails(type, data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}${type}/detail`, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};